import makeList from './makeList.js'

let viewFloor = '重力計室'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '重力計室入口',
        file: './data/I17.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 273.30779054916985, 34.4827586206896 ],
          syowaZoom: [ 262.80623608017817, 436.52561247216033 ],
        },
      },
      { description: '重力計室入口(2)',
        file: './data/I17a_2.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 273.30779054916985, 34.4827586206896 ],
          syowaZoom: [ 282.8507795100223, 496.65924276169267 ],
        },
      },
      { description: '重力計室',
        file: './data/I17b.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 273.30779054916985, 34.4827586206896 ],
          syowaZoom: [ 316.2583518930958, 565.7015590200446 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
